import { Link } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function BillingSuccessPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <CheckCircle2 className="h-10 w-10 text-primary" />
      <h1 className="text-xl font-semibold">Abrechnung aktualisiert</h1>
      <p className="max-w-md text-sm text-muted-foreground">Stripe verarbeitet die Zahlung. Der Plan oder Guthaben-Stand wird nach dem Webhook aktualisiert.</p>
      <Button asChild><Link to="/einstellungen/billing">Zurück zu Abrechnung</Link></Button>
    </main>
  )
}
